import React, { useState } from 'react';
import { Button } from 'components/common';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import TinymceEditor from 'components/common/TinymceEditor';
import { createNote as _createNote, updateNote as _updateNote } from 'redux/crm/project/projectActivitySlice';
const NoteEditor = ({
  projectId, record, onClose,
  createAction = _createNote,
  updateAction = _updateNote,
  submittingSelector = s => s.crm_project_activity.submitting,
}) => {
  const dispatch   = useDispatch();
  const submitting = useSelector(submittingSelector);
  const [content, setContent] = useState(record?.content || '');

  const handleSave = async () => {
    if (!content.trim() || content === '<p></p>') { toast.error('Note content is required.'); return; }

    const action = record
      ? updateAction({ projectId, id: record.id, content })
      : createAction({ projectId, content });

    const res = await dispatch(action);
    if (res.meta.requestStatus === 'fulfilled') {
      toast.success(record ? 'Note updated.' : 'Note saved.');
      onClose();
    } else {
      toast.error(res.payload || 'Failed to save note.');
    }
  };

  return (
    <div className="tw-rounded-lg tw-border tw-border-blue-300 tw-bg-white tw-shadow-md tw-overflow-hidden">
      <TinymceEditor
        value={content}
        handleChange={setContent}
        height="200px"
        initOverride={{
          placeholder: 'Write a note — paste text, tables, or images...',
          toolbar: 'bold italic underline | bullist numlist | link image | removeformat',
          plugins: 'lists link image',
          paste_data_images: true,
        }}
      />
      <div className="tw-flex tw-justify-end tw-gap-2 tw-p-2 tw-border-t tw-border-slate-100 tw-bg-slate-50">
        <Button variant="secondary" size="sm" onClick={onClose} type="button">Cancel</Button>
        <Button variant="primary" size="sm" onClick={handleSave} disabled={submitting}>
          {submitting ? 'Saving...' : record ? 'Update' : 'Save note'}
        </Button>
      </div>
    </div>
  );
};

NoteEditor.propTypes = {
  projectId:          PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  record:             PropTypes.object,
  onClose:            PropTypes.func.isRequired,
  createAction:       PropTypes.func,
  updateAction:       PropTypes.func,
  submittingSelector: PropTypes.func,
};

export default NoteEditor;
